import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

// Function to retrieve toastInfo from localStorage and parse it back into an object
export const useToken = () => {
    const toastInfo = localStorage.getItem("token");
    return toastInfo ? JSON.parse(toastInfo) : null;
};

// Function to serialize the info object to a string and store it in localStorage
export const setToken = (info: any | null) => {
    if (info) {
      const infoWithExpiry = {
        ...info,
        expiry: new Date().getTime() + 30 * 60 * 1000 // current time + 30 mins in milliseconds
      };
      const infoToStore = JSON.stringify(infoWithExpiry);
      localStorage.setItem("token", infoToStore);
    } else {
      localStorage.setItem("token", 'null');
    }
  };
  
export const isTokenExpired = () => {
    const infoFromStorage = localStorage.getItem("token");
    if (!infoFromStorage || infoFromStorage === 'null') {
      return true; // no token or token is 'null'
    }
    
    const info = JSON.parse(infoFromStorage);
    if (!info.expiry) {
      return true; // no expiry info, assume expired
    }
  
    const now = new Date().getTime();
    return now > info.expiry; // true if current time is past the expiry time
  };
  

  export const resetTokenExpiryOnActivity = () => {
    const infoFromStorage = localStorage.getItem("token");
    if (infoFromStorage && infoFromStorage !== 'null') {
      const info = JSON.parse(infoFromStorage);
      setToken({...info, expiry: undefined}); // Remove expiry to let setToken add a new one
    }
  };

